import Image from 'next/image';
import Link from 'next/link';

import { Container, Section, Filial } from './styles';

import { ImPhone } from 'react-icons/im';
import { IoMdMail } from 'react-icons/io';

import { RiArrowRightSLine } from 'react-icons/ri';

import removeAllNonNumberCharacters from '@/utils/removeAllNonNumberCharacters';

interface IFiliais {
  filiais: {
    id: string;
    endereco: string;
    email: string;
    estado: string;
    slug: string;
    telefone: string;
    cidadesAtendidas: {
      nome: string;
    }[];
    diasAtivosEntrega: string[];
    nome: string;
    iframeMaps: string;
    imagemMaps: {
      url: string;
    };
    linkLocalizacao: string;
  }[];
}

const PageContent: React.FC<IFiliais> = ({ filiais }): JSX.Element => {
  return (
    <Container>
      <h1>Filiais</h1>
      <Section>
        {filiais?.map((filial) => (
          <Filial key={filial.id}>
            <a href={filial.linkLocalizacao} target="_blank" rel="noreferrer">
              <Image
                src={filial.imagemMaps?.url}
                alt="Mapa do local"
                quality={100}
                width={360}
                height={160}
              />
            </a>
            <div className="text">
              <h2>{filial.nome}</h2>
              <h3>{filial.estado}</h3>
              <a
                href={`tel:${removeAllNonNumberCharacters(filial.telefone)}`}
                className="contact"
              >
                <ImPhone size={20} /> {filial.telefone}
              </a>
              <a href={`mailto:${filial.email}`} className="contact">
                <IoMdMail size={20} /> {filial.email}
              </a>
              <p>{filial.endereco}</p>
              <Link href={`/filiais/${filial.slug}`} passHref>
                <a>
                  Ver mais <RiArrowRightSLine size={20} />
                </a>
              </Link>
            </div>
          </Filial>
        ))}
      </Section>
    </Container>
  );
};

export default PageContent;
